export default "__VITE_PUBLIC_ASSET__36860460__"